import {CountAmenityType} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenity.type";
import useCountAmenityValueGetter
    from "@CheckOrder/features/amenities/features/countAmenity/hooks/useCountAmenityValueGetter";

/**
 * returns a function which filters out selected count amenities from amenities array (for either single or return leg)
 */
export default function useGetSelectedCountAmenities() {
    const {getCountAmenityValue} = useCountAmenityValueGetter()

    const getSelectedCountAmenities = (countAmenities: CountAmenityType[], direction: "single" | "return") => (
        countAmenities.filter((amenity) => (
            getCountAmenityValue(amenity, direction)
        ))
    )

    return {
        getSelectedCountAmenities,
    }
}